import { useMutation } from 'react-query'

import { api } from '../../../api'
import { type AssetAnalystDomain } from '../../../../types/domain/asset-analyst-domain'
import { type AssetAnalystPersistence } from '../../../../types/persistence/asset-analyst-persistence'

type MutationArgs = {
  id: number
  data: AssetAnalystPersistence
}

const editAssetAnalyst = async (
  id: number,
  data: AssetAnalystPersistence
): Promise<AssetAnalystDomain> => {
  const response = await api.put<AssetAnalystDomain>(
    `/asset-analysts/${id}`,
    data
  )
  return response.data
}

export const useAssetAnalystEditMutation = () => {
  return useMutation('edit-asset-analyst', ({ id, data }: MutationArgs) =>
    editAssetAnalyst(id, data)
  )
}
